import React, { useState } from 'react';
import { Theme } from '@mui/material';

import WindowedSelect from 'react-windowed-select';
import { getGoogleFonts } from './utils';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { components } from './Components';
import { OptionType } from './types';

export interface Props {
	label: string;
	onChange: (value: string | undefined) => void;
	currentFont: string | undefined;
	disable: boolean;
}

const FontSelector = (props: Props) => {
	const classes = useStyles();
	const { label, onChange, currentFont, disable } = props;
	const [googleFonts, setGoogleFonts] = useState<OptionType[] | null>(null);
	const [loading, setLoading] = useState<boolean>(false);

	const fetchFontList = async () => {
		setLoading(true);
		const fontList = await getGoogleFonts();
		const fontOptions = fontList.map((font) => ({
			label: font,
			value: font,
		}));
		setGoogleFonts(fontOptions);
		setLoading(false);
	};

	const handleChange = (value: string | undefined) => {
		onChange(value);
	};

	const handleMenuOpen = () => {
		fetchFontList();
	};

	return (
		<WindowedSelect
			isDisabled={disable}
			classes={classes}
			value={
				!!currentFont
					? {
							label: currentFont,
							value: currentFont,
					  }
					: undefined
			}
			options={googleFonts ?? []}
			menuPlacement="auto"
			onMenuOpen={handleMenuOpen}
			isLoading={loading}
			textFieldLabel={label}
			isClearable
			maxMenuHeight={200}
			TextFieldProps={{
				InputLabelProps: {
					shrink: true,
				},
			}}
			onChange={(inputValue: OptionType) => {
				handleChange(inputValue?.value);
			}}
			onInputChange={(inputValue: OptionType, { action }: { action: string }) => {
				if (action === 'input-change') {
					handleChange(inputValue?.value);
				}
			}}
			components={components}
			windowThreshold={50}
		/>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		valueWrapper: {
			display: 'flex',
			alignItems: 'center',
			flexWrap: 'nowrap',
			flex: 1,
			'& div': {
				display: 'flex',
				flex: 1,
			},
		},
		valueContainer: {
			flexWrap: 'nowrap',
			display: 'flex',
			alignItems: 'center',
			flex: 1,
		},
		paper: {
			position: 'absolute',
			zIndex: 3,
			left: 0,
			width: 'auto',
			minWidth: '100%',
		},
	}),
);

export default FontSelector;
